import { createSlice } from "@reduxjs/toolkit";
import {
  viewGoogleResponse,
  singleGoogleResponse,
  newGoogleResponse,
  updateGoogleResponse,
  deleteGoogleResponse,
  googleResponseByApplicationType,
} from "../actions/googleResponseAction";

const internshipSlice = createSlice({
  name: "googleFormResponse",
  initialState: {
    googleformresponse: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(updateGoogleResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGoogleResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.googleformresponse = action.payload;
      })
      .addCase(updateGoogleResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteGoogleResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGoogleResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.googleformresponse = action.payload;
      })
      .addCase(deleteGoogleResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(singleGoogleResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(singleGoogleResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.googleformresponse = action.payload;
      })
      .addCase(singleGoogleResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
  extraReducers: (builder) => {
    builder
      .addCase(newGoogleResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(newGoogleResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.googleformresponse = action.payload;
      })
      .addCase(newGoogleResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(googleResponseByApplicationType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleResponseByApplicationType.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.googleformresponse = action.payload;
      })
      .addCase(googleResponseByApplicationType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },

  extraReducers: (builder) => {
    builder
      .addCase(viewGoogleResponse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(viewGoogleResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.googleformresponse = action.payload;
      })
      .addCase(viewGoogleResponse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default internshipSlice.reducer;
